import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AumicoPatternModule } from '../pattern/aumico-pattern.module';
import { ActionFooterComponent } from './components/action-footer/action-footer.component';
import { AumLoggedOutFooter } from './components/logged-out-layout/logged-out-footer.component';
import { LoggedOutLayout } from './components/logged-out-layout/logged-out-layout.component';
import { SidebarComponent } from './components/sidebar/sidebar.compontent';
import { SubnavigationComponent } from './components/subnavigation/subnavigation.component';
import { RoutingEffects } from './ngrx/aumico.layout.effects';
import * as fromReducer from './ngrx/aumico.layout.reducer';
import { ActionFooterService } from './services/actionFooter.service';
import { SidenavService } from './services/sidenav.service';
import { SidebarLayout } from './sidebar.layout';
import { I18NextModule } from 'angular-i18next';

@NgModule({
    declarations: [
        SidebarComponent,
        SidebarLayout,
        SubnavigationComponent,
        ActionFooterComponent,
        LoggedOutLayout,
        AumLoggedOutFooter,
    ],
    imports: [
        CommonModule,
        I18NextModule,
        StoreModule.forFeature(fromReducer.layoutFeatureKey, fromReducer.reducer),
        EffectsModule.forFeature([RoutingEffects]),
        RouterModule,
        FlexLayoutModule,
        MatListModule,
        MatSidenavModule,
        MatIconModule,
        AumicoPatternModule,
    ],
    exports: [SidebarLayout, LoggedOutLayout, AumLoggedOutFooter],
    providers: [],
})
export class AumicoLayoutModule {
    static forRoot(): ModuleWithProviders<AumicoLayoutModule> {
        return {
            ngModule: AumicoLayoutModule,
            providers: [SidenavService, ActionFooterService],
        };
    }
}
